import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@newcore/ui/cn';
import { FloatingTopbar } from '@/components/layout/floating-topbar';
import { MobileNavigationMenu } from '@/components/layout/mobile-navigation-menu';
import { useExtensionSync } from '@/hooks/use-extension-sync';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { PageLoader } from '../components/page-loader';
import { PortalPageTransition } from '../components/portal-page-transition';

export const PortalLayout: React.FC = () => {
  const location = useLocation();
  const isMobile = useIsMobile();

  useExtensionSync();

  // The mobile bottom dock only appears on the dashboard and agents surface.
  const showMobileNav =
    isMobile &&
    /^\/[^/]+\/(dashboard|agents)(\/.*)?\/?$/.test(location.pathname);

  return (
    <div className='relative h-dvh w-full overflow-hidden bg-secondary'>
      <FloatingTopbar />

      <main
        className={cn(
          'scrollbar-thin absolute inset-0 overflow-y-auto px-5 py-10 sm:px-8 lg:px-12 lg:py-16',
          showMobileNav && 'pb-16'
        )}
        style={{ scrollbarGutter: 'stable' }}
      >
        {/* Clears the floating bar, which ends at 19px offset + 52px tall. */}
        <div aria-hidden='true' className='h-17.75' />

        <div className='mx-auto min-h-full w-full max-w-190'>
          <Suspense fallback={<PageLoader />}>
            <PortalPageTransition />
          </Suspense>
        </div>
      </main>

      {showMobileNav && <MobileNavigationMenu />}
    </div>
  );
};
